import React, {useState, useEffect} from 'react';
import { TeamLogo } from './teamLogo';

/**
 * Player Box Component
 */
const ClubBox = (props) => {
    const { 
        data = null,
        onClick = () => {},
        selected = false,
        link = true,
        custom = null,
        ...restProps 
    } = props;


    const [ name, setName ] = useState(null);
    const [ image, setImage ] = useState(null);
    const [ uid, setUID ] = useState(null);
    const [ url, setURL ] = useState('#');

    useEffect(() => {

        if ( custom == 'all-teams' ) {
            setImage(<div className="teamLogo clubBox__defaultLogo"></div>);
            setName(<h4 className="acaH5 clubBox__name">All Teams</h4>);

        } else if ( data ) {

            if ( data.hasOwnProperty('name') && data.name ) {
                setName(<h4 className="acaH5 clubBox__name">{ data.hasOwnProperty('name') ? data.name : '' }</h4>);
            }
    
            if ( data.hasOwnProperty('uid') && data.uid ) {
                setImage(<TeamLogo teamId={data.uid} />);
            }
            if ( data.hasOwnProperty('uid') && data.uid ) {
                setUID(data.uid);
            }
            if ( data.hasOwnProperty('url') && data.url ) {
                setURL(data.url);
            }

        }
        

    }, [data]);
    if ( !name ) return;

    // Set up class list
    let classes = 'clubBox';
    if ( selected ) classes += ' clubBox--selected';

    /**
     * Handle click event
     */
    const handleClick = (value) => {
        onClick(value);
    };


    return (
        <>
            { link ? (
                <a href={ url } className={classes}>
                    { image } { name }
                </a>
            ) : (
                <button onClick={() => handleClick(uid)} className={classes}>
                    { image } { name }
                </button>
            ) }
        </>
        
    );
}



/**
 * Export
 */
export { ClubBox };